<template>
    <div class="model-detail-container">
        <!-- <Top></Top> -->
        <div class="detail-main container">
            <!-- 左侧分栏 -->
            <div class="model-left-column">
                <!-- 原有代码保持不变 -->
                <div class="model-showcase">
                    <el-carousel ref="mainCarousel" height="500px" arrow="always" class="main-carousel"
                        @change="handleCarouselChange" :autoplay="false" indicator-position="none">
                        <!-- 关键修改1：添加ref和@contextmenu事件 -->
                        <el-carousel-item v-for="(img, idx) in carouselImages" :key="`img-${idx}`">
                            <div class="carousel-image-wrapper">
                                <img :src="img" :alt="`${fileDate.title || '模型'} 细节图${idx + 1}`"
                                    :data-compress-src="getCompressUrl(idx)" class="carousel-content"
                                    @contextmenu="handleImageContextMenu($event, idx)" @mouseleave="restoreImageSrc(idx)" />
                                
                                <!-- 模型预览大图：右上角可开发票标签 -->
                                <div class="model-tag" v-if="fileDate.whetherInvoice">可开发票</div>
                                <!-- 模型预览大图：左上角官方认证标签 -->
                                <div class="model-official-tag" v-if="fileDate.officialmod">官方认证</div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>

                    <div class="carousel-controls">
                        <div class="thumbnail-list">
                            <div v-for="(img, idx) in carouselImages" :key="`thumb-img-${idx}`" class="thumbnail-item"
                                :class="{ active: currentIndex === idx }" @click="switchToItem(idx)">
                                <img :src="img" :alt="`缩略图${idx + 1}`" class="thumbnail-img" />
                            </div>
                        </div>
                    </div>

                    <div class="model-meta">
                        <div class="model-tags">
                        </div>
                        <h1 class="model-title">{{ fileDate.title }}</h1>
                        <div class="model-price-sales">
                            <span class="price">{{ fileDate.licensingPrices }}云币</span>
                            <span class="sales">已售{{ fileDate.salesVolume }}份</span>
                        </div>
                    </div>
                </div>

                <!-- 其余原有代码保持不变 -->
                <div class="model-desc">
                    <div class="desc-title-bar">
                        <h3 class="desc-title">模型说明</h3>
                    </div>
                    <div class="official-tips">
                        <div class="tips-header">官方提示:</div>
                        <div class="tips-content">
                            <div class="tips-item">
                                1. 版权说明:
                                在本站下载的素材，著作权归原作者所有。当作品未设置商业授权出售模式时，如需获得商业授权，请在购买前联系客服。未经书面授权或签订书面合同，不得以任何形式发行、发布、传播、复制、出租、转让、汇编该素材。
                            </div>
                            <div class="tips-item">
                                2.
                                本内容为三维数字模型，属于虚拟物品，非实体模型，与现实环境中的真实物体存在差异。除非特别说明，模型的结构、精度和细节以预览图和线框图展示为准，预览图中未展示的部分没有设计。如果您有任何疑问，请在购买前联系客服咨询。
                            </div>
                            <div class="tips-item">
                                3. 请仔细阅读描述中的格式、版本、渲染器和插件，通常使用OBJ、FBX等通用格式导入三维软件或引擎中无法直接达到原始文件中展示的渲染效果，需要您手动进行二次调整。<br>
                                详情请参考
                                <a href="javascript:void(0)" class="protocol-link"
                                    @click="openHelpDoc">《通用格式购前帮助文档》</a>。使用非描述中的格式、版本以及渲染环境打开文件可能会有不兼容的问题，或者由于电脑硬件配置不足，导致文件无法正常打开，或打开后运行卡顿情况不在售后服务范围内，请谨慎购买。
                            </div>
                            <div class="tips-item">
                                4. 侵权投诉: 您所购买并下载的素材由发布人进行上传并出售。如果您认为该内容侵犯了您的合法权益，
                                <a href="javascript:void(0)" class="protocol-link"
                                    @click="openRightsRules">请点击查看权利通知规则</a>。
                            </div>
                        </div>
                    </div>
                    <div class="desc-section">
                        <div class="desc-text" v-html="fileDate.instructions || '<p>暂无模型说明</p>'"></div>
                    </div>
                </div>

                <div class="related-models">
                    <h2 class="section-header">相关模型推荐</h2>
                    <div class="models-grid">
                        <div class="model-card" v-for="(item, idx) in relatedModels" :key="idx"
                            @click="handleModelDetail(item.modelId)">
                            <div class="model-img-container">
                                <img :src="item.previewUrl" :alt="item.title" class="model-img" />
                                <!-- 相关模型：可开发票标签（条件渲染） -->
                                <div class="model-tag" v-if="item.whetherInvoice">可开发票</div>
                                <!-- 相关模型：官方认证标签（条件渲染） -->
                                <div class="model-official-tag" v-if="item.officialmod">官方认证</div>
                            </div>
                            <div class="model-info">
                                <h3 class="model-name">{{ item.title }}</h3>
                                <div class="model-meta">
                                    <span class="model-price">{{ item.licensingPrices || '0' }}云币</span>
                                    <span class="model-sales">已售{{ item.salesVolume || '0' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="load-tips" v-if="allRelatedModels.length > 0">
                        <span v-if="!hasMore">已加载全部相关模型</span>
                    </div>
                </div>
            </div>

            <!-- 右侧分栏 -->
            <div class="model-right-panel">
                <!-- 原有代码保持不变 -->
                <div class="license-select">
                    <h3 class="panel-title">选择授权类型</h3>
                    <div class="license-item" :class="{ active: licenseType === 'personal' }"
                        @click="licenseType = 'personal'">
                        <input type="radio" v-model="licenseType" value="personal">
                        <label>个人授权{{ fileDate.releaseLicensing ? "（已拥有）" : "" }}</label>
                        <span class="license-price">{{ fileDate.licensingPrices || "未知" }}云币</span>
                    </div>
                    <div class="license-item" :class="{ active: licenseType === 'enterprise' }"
                        @click="licenseType = 'enterprise'">
                        <input type="radio" v-model="licenseType" value="enterprise">
                        <label>企业授权{{ fileDate.releaseEnterprise ? "（已拥有）" : "" }}</label>
                        <span class="license-price">{{ fileDate.enterprisePrices || "未知" }}云币</span>
                    </div>
                    <div class="license-item" :class="{ active: licenseType === 'enterprise_extend' }"
                        @click="licenseType = 'enterprise_extend'">
                        <input type="radio" v-model="licenseType" value="enterprise_extend">
                        <label>企业扩展授权{{ fileDate.releaseExpand ? "（已拥有）" : "" }}</label>
                        <span class="license-price">{{ fileDate.expandPrices || "未知" }}云币</span>
                    </div>
                    <div class="discount-tag" v-if="fileDate.discount">
                        {{ fileDate.discount }}
                    </div>
                </div>

                <div class="action-btns">
                    <el-button v-if="!getCurrentLicenseHasOwned" type="primary" class="btn primary-btn download-btn"
                        @click="openBuyConfirmDialog()">立即购买</el-button>
                    <el-button v-else type="primary" class="btn primary-btn download-btn"
                        @click="downloadModel()">立即下载</el-button>

                    <el-button type="primary" class="btn secondary-btn cart-btn" @click="getAddMyShoppingCart()"
                        style="margin-left: 0;">加入购物车</el-button>
                    <el-button type="text" class="btn2 collect-btn" :class="{ 'tertiary-btn': fileDate.collect }"
                        @click="AddMyCollection()" style="margin-left: 0;">
                        {{ fileDate.collect ? '已收藏' : '收藏' }}({{ fileDate.favorites || '0' }})
                    </el-button>
                </div>

                <div class="license-scope">
                    <h3 class="panel-title">
                        {{ licenseType === 'personal' ? '个人授权范围' : licenseType === 'enterprise' ? '企业授权范围' : '企业扩展授权范围'
                        }}：
                    </h3>
                    <ul class="scope-list">
                        <li v-for="(item, idx) in getScopeList" :key="idx" :class="{ disabled: !item.available }">
                            <i v-if="item.available" class="el-icon-check-circle"></i>
                            <i v-else class="el-icon-circle-outline"></i>
                            <span>{{ item.text }}</span>
                        </li>
                    </ul>
                </div>

                <div class="right-section">
                    <h3 class="panel-title">文件格式与属性</h3>
                    <div class="file-info">
                        <div class="format-configs-group">
                            <h4>格式配置：</h4>
                            <div class="configs-list">
                                <div class="config-item" v-for="(config, idx) in fileDate.formatConfigs"
                                    :key="`config-${idx}`">
                                    <div class="config-header">
                                        <span class="config-index">格式 {{ idx + 1 }}</span>
                                    </div>
                                    <ul class="config-params">
                                        <li v-if="config.fileFormat">
                                            <span class="param-key">软件：</span>
                                            <span class="param-val">{{ config.fileFormat }}</span>
                                        </li>
                                        <li v-if="config.formatVersion">
                                            <span class="param-key">软件版本：</span>
                                            <span class="param-val">{{ config.formatVersion }}</span>
                                        </li>
                                        <li v-if="config.renderer">
                                            <span class="param-key">渲染器：</span>
                                            <span class="param-val">{{ config.renderer }}</span>
                                        </li>
                                        <li v-if="config.rendererVersion">
                                            <span class="param-key">渲染器版本：</span>
                                            <span class="param-val">{{ config.rendererVersion }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="no-config"
                                    v-if="!fileDate.formatConfigs || fileDate.formatConfigs.length === 0">
                                    暂无格式配置信息
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="model-props">
                        <h4>模型属性：</h4>
                        <div class="props-grid">
                            <div class="prop-item">
                                <span class="prop-key">绑定</span>
                                <span :class="`prop-val ${fileDate.agent ? 'available' : 'unavailable'}`">
                                    {{ fileDate.bind ? '有' : '无' }}
                                </span>
                            </div>
                            <div class="prop-item">
                                <span class="prop-key">动画</span>
                                <span :class="`prop-val ${fileDate.animation ? 'available' : 'unavailable'}`">
                                    {{ fileDate.animation ? '有' : '无' }}
                                </span>
                            </div>
                            <div class="prop-item">
                                <span class="prop-key">材质</span>
                                <span :class="`prop-val ${fileDate.plugins ? 'available' : 'unavailable'}`">
                                    {{ fileDate.material ? '有' : '无' }}
                                </span>
                            </div>
                            <div class="prop-item">
                                <span class="prop-key">贴图</span>
                                <span :class="`prop-val ${fileDate.sticker ? 'available' : 'unavailable'}`">
                                    {{ fileDate.sticker ? '有' : '无' }}
                                </span>
                            </div>
                            <div class="prop-item">
                                <span class="prop-key">AI</span>
                                <span :class="`prop-val ${fileDate.pbrProcess ? 'available' : 'unavailable'}`">
                                    {{ fileDate.aiContent ? '有' : '无' }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="right-section">
                    <h3 class="panel-title">版权信息</h3>
                    <div class="copyright-card">
                        <p>著作权人：{{ fileDate.copyrightOwner || "未知" }}</p>
                        <p>作品登记证书：<a :href="fileDate.copyrightCertificate" class="cert-link" target="blank">查看证书</a></p>
                        <p>版权服务：{{ fileDate.copyrightServices || "未知" }}</p>
                    </div>
                </div> -->

                <div class="right-section">
                    <h3 class="panel-title">发布者信息</h3>
                    <div class="publisher-card">
                        <div class="publisher-avatar" @click="goDetails(fileDate.userID)">
                            <img :src="fileDate.userAvatar || 'http://49.232.163.2:5159/image/30.png'" alt="头像">
                        </div>
                        <div class="publisher-info">
                            <div class="publisher-header">
                                <p class="publisher-name">{{ fileDate.userName || "未知" }}</p>
                                <el-button :class="fileDate.follow ? 'follow-btn followed' : 'follow-btn'"
                                    @click="handleFollow">
                                    {{ fileDate.follow ? '已关注' : '关注' }}
                                </el-button>
                            </div>
                            <p class="publisher-tags">
                                <span class="tag" v-for="tag in publisherTags" :key="tag">{{ tag }}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="right-section">
                    <h3 class="panel-title">分类与关键词</h3>
                    <div class="category-tags">
                        <span class="category-tag">{{ fileDate.oneType[0] || "未知" }}</span>
                        <span class="category-tag">{{ fileDate.twoType[0] || "未知" }}</span>
                        <span class="category-tag">{{ fileDate.styleType[0] || "未知" }}</span>
                    </div>
                    <div class="keyword-tags">
                        <span class="tag" v-for="(tag, idx) in fileDate.keywords" :key="idx">{{ tag }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3D预览弹窗 -->
        <el-dialog title="3D模型预览" :visible.sync="show3dPreview" width="80%" top="20px" append-to-body
            @close="handle3dPreviewClose">
            <div class="model-preview-container">
                <div v-if="isModelLoading" class="loading-3d">
                    <i class="el-icon-loading"></i>
                    <span>3D模型加载中...</span>
                </div>
                <ModelViewer v-else ref="modelViewer" modelUrl="/models/huaping.obj" @load="handleModelLoad" />
            </div>
        </el-dialog>

        <!-- 新增购买确认弹窗 -->
        <el-dialog title="确认购买模型" :visible.sync="showBuyConfirmDialog" append-to-body :close-on-click-modal="false"
            :close-on-press-escape="false" class="buy-confirm-dialog">
            <div class="confirm-content">
                <div class="model-basic-info">
                    <div class="info-row">
                        <span class="info-label">模型名称：</span>
                        <span class="info-value">{{ fileDate.title || '未命名模型' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">模型ID：</span>
                        <span class="info-value">{{ fileDate.modelId || '未知' }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">授权类型：</span>
                        <span class="info-value">
                            {{ licenseType === 'personal' ? '个人授权' : licenseType === 'enterprise' ? '企业授权' : '企业扩展授权' }}
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">购买金额：</span>
                        <span class="info-value price">
                            {{
                                licenseType === 'personal' ? fileDate.licensingPrices :
                                    licenseType === 'enterprise' ? fileDate.enterprisePrices :
                                        fileDate.expandPrices || 0
                            }}云币
                        </span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">已售数量：</span>
                        <span class="info-value">{{ fileDate.salesVolume || 0 }}份</span>
                    </div>
                </div>

                <div class="buy-tips">
                    <i class="el-icon-warning"></i>
                    <span>购买前请确认授权类型及金额，确认购买即视为您已阅读并同意
                        <a href="javascript:void(0)" class="protocol-link" @click="openBuyerAgreement">《智步云上模型网买家协议》</a>
                        与
                        <a href="javascript:void(0)" class="protocol-link"
                            @click="openLicenseAgreement">《智步云上模型网模型授权协议》</a>
                    </span>
                </div>

                <div class="loading-container" v-if="isBuyLoading">
                    <i class="el-icon-loading"></i>
                    <span>正在处理购买请求，请稍候...</span>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="showBuyConfirmDialog = false">取消</el-button>
                <el-button type="primary" @click="confirmBuyModel()" :loading="isBuyLoading" :disabled="isBuyLoading">
                    确认购买
                </el-button>
            </div>
        </el-dialog>

        <!-- <Bottom></Bottom> -->
    </div>
</template>

<script>
import { Carousel, CarouselItem, RadioGroup, RadioButton, Button, Tabs, TabPane, Dialog, MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Top from '../../components/Header.vue';
import Bottom from '../../components/Footer.vue';
import ModelViewer from '../model/ModelViewer.vue';

export default {
    name: 'ModelDetail',
    components: {
        'el-carousel': Carousel,
        'el-carousel-item': CarouselItem,
        'el-button': Button,
        'el-dialog': Dialog,
        Top,
        Bottom,
        ModelViewer
    },
    data() {
        return {
            activeTab: 'desc',
            currentIndex: 0,
            isModelLoading: true,
            show3dPreview: false,
            licenseType: 'personal',
            fileDate: {
                formatConfigs: []
            },
            relatedModels: [],
            allRelatedModels: [], // 补充：存储所有相关模型数据
            showBuyConfirmDialog: false,
            isBuyLoading: false,
            token: localStorage.getItem('token'),
            originalImageUrls: [],
            isRightClicking: false,
            pageSize: 6,         // 每次加载6个
            currentShowCount: 6, // 当前已展示的数量
            hasMore: true        // 是否还有更多数据可加载
        };
    },
    computed: {
        carouselImages() {
            const previewUrls = this.fileDate.previewUrl || [];
            const wireframeUrls = this.fileDate.wireframeUrl || [];
            // 存储原始URL，用于恢复
            this.originalImageUrls = [...previewUrls, ...wireframeUrls];
            return this.originalImageUrls;
        },
        primaryCategory() {
            return this.fileDate.oneType && this.fileDate.oneType.length ? this.fileDate.oneType[0] : '';
        },
        keywordsArray() {
            return this.fileDate.keywords ? this.fileDate.keywords.split(',').filter(tag => tag.trim()) : [];
        },
        publisherTags() {
            return this.fileDate.publisherTags ? this.fileDate.publisherTags.split(',').filter(tag => tag.trim()) : [];
        },
        categoryColor() {
            const colorMap = {
                '人物模型': '#0ea5e9',
                '建筑模型': '#7c3aed',
                '场景模型': '#f97316',
                '武器模型': '#ef4444',
            };
            return colorMap[this.primaryCategory] || '#94a3b8';
        },
        getScopeList() {
            const scopes = this.fileDate.scopes;
            return scopes[this.licenseType];
        },
        getCurrentLicenseHasOwned() {
            const licenseOwnedMap = {
                personal: this.fileDate.releaseLicensing,
                enterprise: this.fileDate.releaseEnterprise,
                enterprise_extend: this.fileDate.releaseExpand
            };
            return Boolean(licenseOwnedMap[this.licenseType] || false);
        }
    },
    methods: {
        // 关键修改3：获取对应索引的压缩图片地址
        getCompressUrl(index) {
            const previewPictures = this.fileDate.previewPictures || [];
            const wireframePictures = this.fileDate.wireframePictures || [];
            const compressUrls = [...previewPictures, ...wireframePictures];

            // 如果压缩图片不存在，返回原图
            return compressUrls[index] || this.originalImageUrls[index] || '';
        },

        // 关键修改4：处理图片右键事件
        handleImageContextMenu(event, index) {
            this.isRightClicking = true;
            const imgElement = event.target;
            const compressUrl = this.getCompressUrl(index);

            // 替换为压缩图片地址
            if (compressUrl && imgElement) {
                imgElement.src = compressUrl;
            }

            // 监听鼠标弹起事件，恢复原图（处理右键菜单关闭）
            setTimeout(() => {
                const restoreHandler = (e) => {
                    if (e.button === 2) { // 右键弹起
                        this.restoreImageSrc(index);
                        document.removeEventListener('mouseup', restoreHandler);
                    }
                };
                document.addEventListener('mouseup', restoreHandler);
            }, 10);
        },

        // 关键修改5：恢复图片原始地址
        restoreImageSrc(index) {
            if (!this.isRightClicking) return;

            this.$nextTick(() => {
                // 修复：通过carouselImages遍历DOM，而非不存在的carouselImage ref
                const imgElements = document.querySelectorAll('.carousel-content');
                if (imgElements && imgElements[index]) {
                    imgElements[index].src = this.originalImageUrls[index] || '';
                }
                this.isRightClicking = false;
            });
        },

        goDetails(userID) {
            const routeInfo = this.$router.resolve({
                path: '/designer',
                query: {
                    id: userID
                }
            });
            window.open(routeInfo.href, '_blank');
        },
        openHelpDoc() {
            const routeData = this.$router.resolve({
                path: '/protocol/help-doc'
            });
            window.open(routeData.href, '_blank');
        },
        openRightsRules() {
            const routeData = this.$router.resolve({
                path: '/protocol/rights-rules'
            });
            window.open(routeData.href, '_blank');
        },
        openBuyerAgreement() {
            const routeData = this.$router.resolve({
                path: '/protocol/buyer-doc'
            });
            window.open(routeData.href, '_blank');
        },
        openLicenseAgreement() {
            const routeData = this.$router.resolve({
                path: '/protocol/license-doc'
            });
            window.open(routeData.href, '_blank');
        },
        async AddMyCollection() {
            if (this.token) {
                try {
                    let releaseModel = '';
                    if (this.licenseType == 'personal') {
                        releaseModel = '个人授权';
                    } else if (this.licenseType == 'enterprise') {
                        releaseModel = '企业授权';
                    } else {
                        releaseModel = '企业扩展授权';
                    }
                    const isCollecting = !this.fileDate.collect;
                    const apiMethod = isCollecting
                        ? this.$apiFun.getAddMyCollection
                        : this.$apiFun.getCancelCollection;

                    const res = await this.$apiFun.getAddMyCollection({
                        modelId: this.fileDate.modelId,
                        releaseModel: releaseModel,
                    });
                    if (res.status === 200) {
                        this.fileDate.collect = isCollecting;
                        this.fileDate.favorites = isCollecting
                            ? (this.fileDate.favorites || 0) + 1
                            : Math.max(0, (this.fileDate.favorites || 1) - 1);

                        this.$message.success(isCollecting ? '收藏成功！' : '取消收藏成功！');
                    } else if (res.status === 401 || res.status === 0) {
                        this.$message.warning(res.msg);
                        this.$router.push('/login');
                        return;
                    } else {
                        this.$message.error(`${isCollecting ? '收藏' : '取消收藏'}失败：${res.message || '未知错误'}`);
                    }
                } catch (err) {
                    console.error('收藏操作失败：', err);
                    this.$message.error('网络异常，请稍后重试');
                }
            } else {
                this.$message.warning('请先登录后再进行收藏操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        openBuyConfirmDialog() {
            if (this.token) {
                if (!this.fileDate.modelId) {
                    this.$message.error('模型ID不存在，无法购买');
                    return;
                }

                const currentPrice = this.licenseType === 'personal' ? this.fileDate.licensingPrices :
                    this.licenseType === 'enterprise' ? this.fileDate.enterprisePrices :
                        this.fileDate.expandPrices;

                if (!currentPrice || currentPrice < 0) {
                    this.$message.error('模型价格异常，无法购买');
                    return;
                }

                this.showBuyConfirmDialog = true;
            } else {
                this.$message.warning('请先登录后再进行购买操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        async confirmBuyModel() {
            try {
                this.isBuyLoading = true;

                let currentPrice = 0;
                if (this.licenseType === 'personal') {
                    currentPrice = this.fileDate.licensingPrices;
                } else if (this.licenseType === 'enterprise') {
                    currentPrice = this.fileDate.enterprisePrices;
                } else {
                    currentPrice = this.fileDate.expandPrices;
                }

                const res = await this.$apiFun.postBuyNows({
                    modelId: [this.fileDate.modelId],
                    amounts: [currentPrice],
                });

                if (res.status === 200) {
                    this.$message.success("模型购买成功！您可以立即下载");
                    this.showBuyConfirmDialog = false;
                    const licenseFieldMap = {
                        personal: 'releaseLicensing',
                        enterprise: 'releaseEnterprise',
                        enterprise_extend: 'releaseExpand'
                    };
                    this.fileDate[licenseFieldMap[this.licenseType]] = true;
                } else if (res.status === 401 || res.status === 0) {
                    this.$message.warning(res.msg);
                    this.$router.push('/login');
                    return;
                } else if (res.status === 888) {
                    try {
                        const confirmResult = await MessageBox.confirm(
                            '账户余额不足，是否前往充值？',
                            '余额不足',
                            {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }
                        );

                        if (confirmResult === 'confirm') {
                            const routeInfo = this.$router.resolve({
                                path: '/dashboard/buyer/recharge'
                            });
                            window.open(routeInfo.href, '_blank');
                        }
                    } catch (err) {
                        console.log('用户取消充值');
                    }
                } else {
                    this.$message.error(`购买失败：${res.message || '未知错误'}`);
                }
            } catch (err) {
                console.error('模型购买失败:', err);
                this.$message.error('网络异常，购买请求失败，请稍后重试');
            } finally {
                this.isBuyLoading = false;
            }
        },
        downloadModel() {
            const id = this.$route.query.id
            this.$apiFun.getDownloadFile({
                modelId: id,
            }).then(res => {
                if (res.status === 200) {
                    window.open(res.obj, '_blank')
                } else {
                    this.$message.error(res.msg || '模型下载失败');
                }
            }).catch(err => {
                this.$message.error('模型下载调用失败');
            });
        },
        async getAddMyShoppingCart() {
            if (this.token) {
                try {
                    let releaseModel = '';
                    if (this.licenseType == 'personal') {
                        releaseModel = '个人授权';
                    } else if (this.licenseType == 'enterprise') {
                        releaseModel = '企业授权';
                    } else {
                        releaseModel = '企业扩展授权';
                    }
                    const res = await this.$apiFun.postAddMyShoppingCart({
                        modelId: this.fileDate.modelId,
                        releaseModel: releaseModel,
                    });
                    if (res.status == 200) {
                        this.$message.success("模型加购成功");
                    } else if (res.status === 401 || res.status === 0) {
                        this.$message.warning(res.msg);
                        this.$router.push('/login');
                        return;
                    } else if (res.status == 888) {
                        this.$message.warning("模型已加入购物车，不可多次添加");
                    } else if (res.status == 999) {
                        this.$message.warning("模型已购买无法加购，请直接下载");
                    }
                } catch (err) {
                    console.error('获取模型详情失败:', err);
                }
            } else {
                this.$message.warning('请先登录后再进行加购操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        async detail() {
            // 新增：切换模型时重置分页参数
            this.allRelatedModels = [];
            this.relatedModels = [];
            this.currentShowCount = 6;
            this.hasMore = true;
            this.isModelLoading = true;

            try {
                const res = await this.$apiFun.getFileDate({ modelId: this.searchKey });
                if (res.status === 200) {
                    const fileData = {
                        ...res.obj,
                        formatConfigs: Array.isArray(res.obj.formatConfigs) ? res.obj.formatConfigs : []
                    };
                    this.fileDate = { ...this.fileDate, ...fileData };
                    await this.getRelatedModels(); // 获取所有相关模型并初始化展示
                }
            } catch (err) {
                console.error('获取模型详情失败:', err);
                this.isModelLoading = false;
            }
        },
        async getRelatedModels() {
            try {
                // 一次性获取所有相关模型数据
                const res = await this.$apiFun.getRelatedModels({
                    id: this.fileDate.modelId // 无需传分页参数给后台
                });
                if (res.status === 200) {
                    this.allRelatedModels = res.obj || []; // 全部数据存入allRelatedModels
                    // 初始化：默认只展示前6个
                    this.relatedModels = this.allRelatedModels.slice(0, this.pageSize);
                    // 判断是否有更多数据（总数量 > 已展示数量则有更多）
                    this.hasMore = this.allRelatedModels.length > this.currentShowCount;
                }
            } catch (err) {
                console.error('获取相关模型失败:', err);
                this.allRelatedModels = [];
                this.relatedModels = [];
                this.hasMore = false;
            } finally {
                this.isModelLoading = false;
            }
        },
        // 前端截取数据加载更多
        loadMoreRelatedModels() {
            // 无更多数据则直接返回
            if (!this.hasMore) return;
            // 计算下一次要展示的数量（当前已展示 + 6）
            const nextCount = this.currentShowCount + this.pageSize;
            // 截取对应数量的数据
            this.relatedModels = this.allRelatedModels.slice(0, nextCount);
            // 更新已展示数量
            this.currentShowCount = nextCount;
            // 判断是否还有更多（已展示数量 >= 总数量则无更多）
            this.hasMore = this.currentShowCount < this.allRelatedModels.length;
        },
        handleScroll() {
            // 避免无意义触发（无更多/数据为空时跳过）
            if (!this.hasMore || this.allRelatedModels.length === 0) return;
            // 获取滚动相关参数（兼容各浏览器）
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight || window.innerHeight;
            const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            // 滚动条距离底部小于100px时触发加载
            if (scrollTop + clientHeight >= scrollHeight - 100) {
                this.loadMoreRelatedModels();
            }
        },
        async handleFollow() {
            if (this.token) {

                const isFollow = !this.fileDate.follow;

                try {
                    const res = await this.$apiFun.getAddMyInterest({ followedUser: this.fileDate.userID });

                    if (res.status === 200) {
                        this.fileDate.follow = isFollow;
                        this.$message.success(isFollow ? '关注成功！' : '取消关注成功！');
                    } else if (res.status === 401 || res.status === 0) {
                        this.$message.warning(res.msg);
                        this.$router.push('/login');
                        return;
                    } else {
                        this.$message.error(`${isFollow ? '关注' : '取消关注'}失败：${res.message || '操作异常'}`);
                    }
                } catch (err) {
                    console.error(`${isFollow ? '关注' : '取消关注'}接口请求失败：`, err);
                    this.$message.error('网络异常，操作失败，请稍后重试');
                }
            } else {
                this.$message.warning('请先登录后再进行关注操作');
                localStorage.removeItem('userData');
                localStorage.removeItem('token');
                this.$router.push('/login');
                return;
            }
        },
        handleModelDetail(modelId) {
            // this.$router.push({ path: `/model/${modelId}` });
            const routeInfo = this.$router.resolve({ path: '/detail', query: { id: modelId } });
            window.open(routeInfo.href, '_blank');
        },
        handleCarouselChange(index) {
            this.currentIndex = index;
        },
        switchToItem(index) {
            if (index >= 0 && index < this.carouselImages.length) {
                this.currentIndex = index;
                this.$refs.mainCarousel.setActiveItem(index);
            }
        },
        handleModelLoad() {
            this.isModelLoading = false;
        },
        handle3dPreviewClose() {
            this.isModelLoading = true;
            if (this.$refs.modelViewer) {
            }
        },
        handleResize() {
            this.$nextTick(() => {
                document.body.style.overflow = 'auto';
            });
        }
    },
    mounted() {
        this.searchKey = this.$route.query.id || '';
        this.detail();

        window.addEventListener('resize', this.handleResize);

        // 优化：将mouseup事件监听提取为方法，避免匿名函数无法解绑
        this.handleMouseUp = (e) => {
            if (e.button === 2) {
                this.isRightClicking = false;
            }
        };
        document.addEventListener('mouseup', this.handleMouseUp);

        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('mouseup', this.handleMouseUp); // 现在可以正确解绑
        window.removeEventListener('scroll', this.handleScroll);
        // 重置分页参数
        this.allRelatedModels = [];
        this.relatedModels = [];
        this.currentShowCount = 6;
        this.hasMore = true;
    },
};
</script>

<style lang="less" scoped>
// 原有样式保持不变
@base-deep: #0f1118;
@base-darker: #080a12;
@primary: #e53935;
@primary-light: #ef5350;
@primary-dark: #d32f2f;
@secondary: #2196f3;
@secondary-light: #42a5f5;
@tertiary: #334155;
@tertiary-hover: #475569;
@accent: #7c3aed;
@text-primary: #fff;
@text-secondary: #94a3b8;
@border-color: rgba(148, 163, 184, 0.1);
@disabled-color: #666;

.model-detail-container {
    background-color: @base-deep;
    color: @text-primary;
    min-height: 100vh;
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    padding: 0 15px;
    overflow-x: hidden;
    box-sizing: border-box;
}

.container {
    width: 100%;
    max-width: 1880px;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
}

.detail-main {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: clamp(1rem, 2vw, 2rem);
    margin-bottom: clamp(2rem, 3vw, 3rem);
    width: 100%;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
}

.model-left-column {
    display: flex;
    flex-direction: column;
    gap: clamp(1rem, 2vw, 2rem);
    width: 100%;
}

.model-showcase {
    background-color: @base-darker;
    border-radius: 8px;
    padding: clamp(1rem, 1.5vw, 1.5rem);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border: 1px solid @border-color;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.main-carousel {
    width: 100%;
    height: clamp(280px, 50vw, 500px) !important;

    .el-carousel__container {
        border-radius: 8px;
        overflow: hidden;
        background-color: #1a1a1a;
        width: 100%;
        height: 100%;
    }

    .carousel-content {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
    }

    .el-carousel__arrow {
        width: clamp(30px, 4vw, 40px);
        height: clamp(30px, 4vw, 40px);
        background-color: rgba(229, 57, 53, 0.5);

        &:hover {
            background-color: @primary;
        }
    }

    @media (max-width: 576px) {
        .el-carousel__arrow {
            display: none;
        }
    }
}

/* 新增：预览图标签容器样式 */
.carousel-image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    
    .model-tag {
        position: absolute;
        top: 1rem;
        right: 1rem;
        background: linear-gradient(135deg, @primary, @accent);
        color: #fff;
        font-size: clamp(0.8rem, 1.2vw, 1rem);
        padding: 0.3rem 0.8rem;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(229, 57, 53, 0.3);
        z-index: 10;
        white-space: nowrap;
    }
    
    .model-official-tag {
        position: absolute;
        top: 1rem;
        left: 1rem;
        background: rgba(245, 158, 11, 0.9);
        color: #fff;
        font-size: clamp(0.8rem, 1.2vw, 1rem);
        padding: 0.3rem 0.8rem;
        border-radius: 4px;
        z-index: 10;
        white-space: nowrap;
    }
}

.carousel-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    gap: 1rem;
    flex-wrap: wrap;

    .thumbnail-list {
        flex: 1;
        display: flex;
        gap: 0.8rem;
        overflow-x: auto;
        padding-bottom: 0.5rem;
        min-width: 200px;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: @primary;
            border-radius: 2px;
        }
    }

    .preview-3d-btn {
        min-width: clamp(100px, 15vw, 120px);
        padding: 0.5rem 1rem;
        background-color: @accent;
        color: white;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        transition: all 0.3s;
        flex-shrink: 0;

        &:hover {
            background-color: darken(@accent, 10%);
            box-shadow: 0 2px 8px rgba(124, 58, 237, 0.4);
        }
    }
}

.thumbnail-item {
    width: clamp(80px, 15vw, 100px);
    height: clamp(48px, 9vw, 60px);
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #222;

    &.active {
        border-color: @primary;
        box-shadow: 0 0 8px rgba(229, 57, 53, 0.6);
    }

    &:hover:not(.active) {
        border-color: @text-secondary;
    }

    .thumbnail-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.model-meta {
    padding: 1rem 0;
    width: 100%;

    .model-tags {
        display: flex;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
        flex-wrap: wrap;

        .tag {
            padding: 0.3rem 0.8rem;
            border-radius: 4px;
            font-size: clamp(0.8rem, 1vw, 0.9rem);
            color: #fff;

            &.category-tag {
                background-color: @accent;
            }
        }
    }

    .model-title {
        font-size: clamp(1.2rem, 3vw, 2rem);
        margin-bottom: 1rem;
        color: @text-primary;
        word-wrap: break-word;
        line-height: 1.3;
    }

    .model-price-sales {
        display: flex;
        gap: clamp(1rem, 2vw, 1.5rem);
        align-items: center;
        flex-wrap: wrap;

        .price {
            font-size: clamp(1.2rem, 2vw, 1.5rem);
            color: @primary;
            font-weight: 600;
        }

        .sales {
            color: @text-secondary;
            line-height: 35px;
            font-size: clamp(0.9rem, 1.2vw, 1rem);
        }
    }
}

.model-desc {
    background-color: @base-darker;
    border-radius: 8px;
    padding: clamp(1rem, 1.5vw, 1.5rem);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border: 1px solid @border-color;
    width: 100%;
    box-sizing: border-box;

    .desc-title-bar {
        margin-bottom: 1rem;
        padding-bottom: 0.5rem;
    }

    .desc-title {
        font-size: clamp(1.2rem, 2vw, 1.5rem);
        color: @text-primary;
        margin-bottom: 1.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 2px solid @primary;
        display: inline-block;
    }

    .desc-section {
        .desc-text {
            color: @text-primary;
            line-height: 1.8;
            font-size: clamp(0.9rem, 1.2vw, 1rem);

            p {
                margin: 0 0 1rem;
            }

            strong {
                color: @text-primary;
                font-weight: bold;
            }
        }
    }
}

.protocol-link {
    color: #409EFF;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        color: #66b1ff;
    }
}

.official-tips {
    background-color: rgba(20, 22, 30, 0.6);
    border-radius: 4px;
    border: 1px solid rgba(148, 163, 184, 0.1);
    padding: clamp(0.8rem, 1.5vw, 15px);
    margin-bottom: 15px;
    color: #ACACAC;
    line-height: 1.8;
    font-size: clamp(0.8rem, 1.1vw, 0.9rem);

    .tips-header {
        color: #E3E3E3;
        font-weight: bold;
        margin-bottom: 10px;
        font-size: clamp(0.9rem, 1.2vw, 1rem);
    }

    .tips-item {
        margin-bottom: 12px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .protocol-link {
        color: #409EFF;
        text-decoration: none;
        cursor: pointer;

        &:hover {
            color: #66b1ff;
        }
    }
}

.related-models {
    background-color: @base-darker;
    border-radius: 8px;
    padding: clamp(1rem, 1.5vw, 1.5rem);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border: 1px solid @border-color;
    width: 100%;
    margin-bottom: 2rem;
    box-sizing: border-box;
}

.section-header {
    font-size: clamp(1.2rem, 2vw, 1.5rem);
    color: @text-primary;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid @primary;
    display: inline-block;
}

.models-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(clamp(220px, 100%/3, 280px), 1fr));
    gap: clamp(1rem, 1.5vw, 1.5rem);
    width: 100%;

    @media (max-width: 768px) {
        grid-template-columns: repeat(auto-fill, minmax(clamp(200px, 50%, 280px), 1fr));
    }

    @media (max-width: 576px) {
        grid-template-columns: 1fr;
    }
}

.model-card {
    background-color: rgba(15, 17, 24, 0.5);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    transition: all 0.3s;
    cursor: pointer;
    border: 1px solid @border-color;
    width: 100%;
    box-sizing: border-box;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(229, 57, 53, 0.15);
        border-color: rgba(229, 57, 53, 0.2);
    }

    .model-img-container {
        position: relative;
        width: 100%;
        aspect-ratio: 4/3;
        overflow: hidden;

        .model-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
            filter: brightness(0.7);
        }

        .model-tag {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
            background: linear-gradient(135deg, @primary, @accent);
            color: #fff;
            font-size: clamp(0.7rem, 1vw, 0.8rem);
            padding: 0.2rem 0.5rem;
            border-radius: 2px;
            box-shadow: 0 2px 4px rgba(229, 57, 53, 0.3);
            white-space: nowrap;
        }

        .model-official-tag {
            position: absolute;
            top: 0.5rem;
            left: 0.5rem;
            background: rgba(245, 158, 11, 0.9);
            color: #fff;
            font-size: clamp(0.7rem, 1vw, 0.8rem);
            padding: 0.2rem 0.5rem;
            border-radius: 2px;
            white-space: nowrap;
            z-index: 10;
        }
    }

    .model-info {
        padding: clamp(0.8rem, 1.2vw, 1rem);
        box-sizing: border-box;

        .model-name {
            font-size: clamp(0.9rem, 1.2vw, 1rem);
            color: @text-primary;
            margin-bottom: 0.5rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-wrap: break-word;
        }

        .model-meta {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-top: 0.5rem;
            border-top: 1px solid @border-color;
            flex-wrap: wrap;
            gap: 0.5rem;

            .model-price {
                color: @primary-light;
                font-weight: 600;
                font-size: clamp(0.9rem, 1.2vw, 1rem);
            }

            .model-sales {
                color: @text-secondary;
                font-size: clamp(0.8rem, 1vw, 0.9rem);
            }
        }
    }
}

.model-right-panel {
    background-color: @base-darker;
    border-radius: 8px;
    padding: clamp(1rem, 1.5vw, 1.5rem);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    border: 1px solid @border-color;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 992px) {
        margin-bottom: 2rem;
    }
}

.license-select {
    margin-bottom: clamp(1rem, 1.5vw, 1.5rem);

    .panel-title {
        font-size: clamp(1rem, 1.5vw, 1.2rem);
        color: @text-primary;
        margin-bottom: 1rem;
    }

    .license-item {
        display: flex;
        align-items: center;
        padding: 0.8rem 1rem;
        border-radius: 4px;
        margin-bottom: 0.5rem;
        cursor: pointer;
        transition: all 0.3s;
        font-size: clamp(0.9rem, 1.1vw, 1rem);

        &.active {
            background-color: rgba(229, 57, 53, 0.1);
            border-left: 3px solid @primary;
        }

        input {
            margin-right: 0.5rem;
            accent-color: @primary;
        }

        label {
            flex: 1;
            cursor: pointer;
        }

        .license-price {
            color: @primary;
            font-weight: 600;
            flex-shrink: 0;
        }
    }

    .discount-tag {
        background-color: rgba(255, 152, 0, 0.1);
        color: #ff9800;
        padding: 0.3rem 0.8rem;
        border-radius: 4px;
        font-size: clamp(0.8rem, 1vw, 0.9rem);
        margin-top: 0.5rem;
        display: inline-block;
    }
}

.action-btns {
    display: flex;
    gap: clamp(0.5rem, 1vw, 1rem);
    margin-bottom: clamp(1rem, 1.5vw, 1.5rem);
    width: 100%;
    flex-wrap: wrap;

    .btn,
    .btn2 {
        padding: 0.8rem 0;
        border-radius: 4px;
        font-size: clamp(0.85rem, 1.1vw, 14px);
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;
        flex: 1;
        min-width: clamp(120px, 30%, 150px);
        text-align: center;
        height: 40px;
        line-height: 1;
        box-sizing: border-box;
    }

    .primary-btn {
        background-color: @primary;
        color: #fff;
        border: none;

        &:hover {
            background-color: @primary-dark;
            color: #fff;
        }
    }

    .secondary-btn {
        background-color: @secondary;
        color: #fff;
        border: none;

        &:hover {
            background-color: @secondary-light;
            color: #fff;
        }
    }

    .collect-btn {
        background-color: @tertiary;
        color: #fff;
        border: 1px solid @tertiary;

        &:hover {
            background-color: @tertiary-hover;
            color: @text-primary;
        }
    }

    .tertiary-btn {
        background-color: @tertiary;
        color: @text-secondary;
        border: 1px solid @tertiary;

        &:hover {
            background-color: @tertiary-hover;
            color: @text-primary;
        }
    }
}

.license-scope {
    margin-bottom: clamp(1rem, 1.5vw, 1.5rem);

    .panel-title {
        font-size: clamp(1rem, 1.5vw, 1.2rem);
        color: @text-primary;
        margin-bottom: 1rem;
    }

    .scope-list {
        list-style: none;
        padding: 0;
        margin-bottom: 1rem;

        li {
            color: @text-secondary;
            margin-bottom: 0.5rem;
            font-size: clamp(0.85rem, 1vw, 0.9rem);
            transition: all 0.3s;
            display: flex;
            align-items: flex-start;
            line-height: 1.5;

            &.disabled {
                color: @disabled-color;
            }

            i {
                margin-right: 8px;
                font-size: 14px;
                margin-top: 2px;
            }

            .el-icon-check-circle {
                color: @primary;
            }

            .el-icon-circle-outline {
                color: @disabled-color;
            }
        }
    }
}

.right-section {
    margin-bottom: clamp(1.5rem, 2vw, 2rem);
    border-bottom: 1px solid @border-color;
    padding-bottom: 1rem;
    font-size: clamp(0.9rem, 1.1vw, 1rem);

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .panel-title {
        font-size: clamp(1rem, 1.3vw, 1.1rem);
        color: @text-primary;
        margin-bottom: 1rem;
        border-left: 3px solid @primary;
        padding-left: 0.5rem;
    }

    .copyright-card,
    .publisher-card,
    .category-tags,
    .keyword-tags,
    .file-info,
    .model-props {
        background-color: rgba(15, 17, 24, 0.5);
        border-radius: 4px;
        padding: clamp(0.8rem, 1.2vw, 1rem);
        box-sizing: border-box;
    }
}

.file-info {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;

    .format-configs-group {
        h4 {
            font-size: clamp(0.95rem, 1.2vw, 1rem);
            color: @primary;
            margin-bottom: 0.8rem;
            padding-bottom: 0.3rem;
            border-bottom: 1px solid @border-color;
        }

        .configs-list {
            .config-item {
                background-color: rgba(20, 22, 30, 0.6);
                border-radius: 4px;
                padding: clamp(0.6rem, 1vw, 0.8rem);
                margin-bottom: 0.8rem;
                border: 1px solid rgba(148, 163, 184, 0.1);
                font-size: clamp(0.85rem, 1vw, 0.9rem);

                .config-header {
                    margin-bottom: 0.5rem;
                    padding-bottom: 0.5rem;
                    border-bottom: 1px solid rgba(148, 163, 184, 0.05);

                    .config-index {
                        color: @primary-light;
                        font-size: clamp(0.85rem, 1vw, 0.9rem);
                        font-weight: 500;
                    }
                }

                .config-params {
                    list-style: none;
                    padding: 0;

                    li {
                        display: flex;
                        margin-bottom: 0.4rem;
                        line-height: 1.5;
                        font-size: clamp(0.8rem, 1vw, 0.9rem);
                        flex-wrap: wrap;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .param-key {
                            color: @text-primary;
                            min-width: clamp(70px, 15vw, 80px);
                            flex-shrink: 0;
                        }

                        .param-val {
                            color: @text-secondary;
                            flex: 1;
                            word-wrap: break-word;
                        }
                    }
                }
            }

            .no-config {
                color: @text-secondary;
                font-size: clamp(0.85rem, 1vw, 0.9rem);
                text-align: center;
                padding: 1rem;
            }
        }
    }
}

.model-props {
    margin-top: 1rem;

    h4 {
        font-size: clamp(0.95rem, 1.2vw, 1rem);
        color: @primary;
        margin-bottom: 0.8rem;
        padding-bottom: 0.3rem;
        border-bottom: 1px solid @border-color;
    }

    .props-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(clamp(120px, 33.33%, 150px), 1fr));
        gap: 1rem;

        @media (max-width: 576px) {
            grid-template-columns: repeat(2, 1fr);
        }

        .prop-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: clamp(0.85rem, 1vw, 0.9rem);
            padding: 0.6rem 0.8rem;
            background-color: rgba(20, 22, 30, 0.6);
            border-radius: 4px;
            border: 1px solid rgba(148, 163, 184, 0.1);

            .prop-key {
                color: @text-primary;
                flex-shrink: 0;
                font-weight: 500;
            }

            .prop-val {
                &.available {
                    color: #4caf50;
                    font-weight: 600;
                }

                &.unavailable {
                    color: @disabled-color;
                }
            }
        }
    }
}

.copyright-card {
    p {
        margin-bottom: 0.5rem;
        color: @text-secondary;
        font-size: clamp(0.85rem, 1vw, 0.9rem);
        line-height: 1.5;

        &:last-child {
            margin-bottom: 0;
        }

        .cert-link {
            color: @primary;
            text-decoration: underline;
            cursor: pointer;
            word-wrap: break-word;
        }
    }
}

.publisher-card {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.8rem, 1.5vw, 1rem);
    flex-wrap: wrap;

    .publisher-avatar {
        cursor: pointer;
        flex-shrink: 0;

        img {
            width: clamp(50px, 10vw, 60px);
            height: clamp(50px, 10vw, 60px);
            border-radius: 10%;
            object-fit: cover;
            margin-top: 0.2rem;
        }
    }

    .publisher-info {
        flex: 1;
        min-width: 200px;

        .publisher-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
            flex-wrap: wrap;
            gap: 0.5rem;

            .publisher-name {
                font-size: clamp(0.95rem, 1.2vw, 1rem);
                color: @text-primary;
                margin: 0;
                word-wrap: break-word;
            }

            .follow-btn {
                background-color: transparent;
                border: 1px solid @primary;
                color: @primary;
                padding: 4px 12px;
                border-radius: 4px;
                font-size: clamp(0.85rem, 1vw, 0.9rem);
                cursor: pointer;
                transition: all 0.3s;
                white-space: nowrap;

                &:hover {
                    background-color: rgba(229, 57, 53, 0.1);
                }

                &.followed {
                    background-color: @primary;
                    color: #fff;

                    &:hover {
                        background-color: @primary-dark;
                    }
                }
            }
        }

        .publisher-tags {
            .tag {
                display: inline-block;
                padding: 0.2rem 0.5rem;
                border-radius: 4px;
                font-size: clamp(0.75rem, 1vw, 0.8rem);
                margin-right: 0.5rem;
                margin-bottom: 0.5rem;
                background-color: rgba(124, 58, 237, 0.2);
                color: #7c3aed;
                word-wrap: break-word;
                max-width: 100%;
            }
        }
    }
}

.category-tags {
    .category-tag {
        background-color: @accent;
        padding: 0.3rem 0.8rem;
        border-radius: 4px;
        display: inline-block;
        margin-bottom: 0.5rem;
        margin-right: 0.5rem;
        font-size: clamp(0.85rem, 1vw, 0.9rem);
        word-wrap: break-word;
    }
}

.keyword-tags {
    .tag {
        display: inline-block;
        padding: 0.2rem 0.5rem;
        border-radius: 4px;
        font-size: clamp(0.75rem, 1vw, 0.8rem);
        margin-right: 0.5rem;
        margin-bottom: 0.5rem;
        background-color: rgba(148, 163, 184, 0.2);
        color: @text-secondary;
        max-width: calc(50% - 0.25rem);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        @media (max-width: 576px) {
            max-width: 100%;
        }
    }
}

.model-preview-container {
    width: 100%;
    height: clamp(300px, 70vh, 70vh);
    position: relative;
    background-color: #0a0a0a;
    border-radius: 4px;
    overflow: hidden;

    .loading-3d {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: @primary;
        font-size: clamp(16px, 2vw, 18px);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;

        .el-icon-loading {
            font-size: clamp(30px, 5vw, 36px);
            animation: rotate 1s linear infinite;
        }
    }
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

::v-deep .el-dialog {
    display: flex;
    flex-direction: column;
    max-width: 95vw;
}

::v-deep .el-dialog__body {
    flex: 1;
    padding: 0;
    overflow: hidden;
}

::v-deep .el-dialog__header {
    border-bottom: 1px solid @border-color;
    margin-bottom: 1rem;
}

::v-deep .buy-confirm-dialog {
    width: clamp(95vw, 600px, 600px) !important;
    position: fixed;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    overflow: hidden;
    max-height: 95vh;

    .el-dialog__header {
        background-color: @base-darker;
        border-bottom: 1px solid @border-color;
        padding: clamp(10px, 2vw, 15px) clamp(15px, 2vw, 20px);
        margin: 0;

        .el-dialog__title {
            color: @text-primary;
            font-size: clamp(14px, 1.8vw, 16px);
            font-weight: 600;
        }

        .el-dialog__headerbtn .el-dialog__close {
            color: @text-secondary;
            font-size: clamp(16px, 2vw, 18px);

            &:hover {
                color: @primary;
            }
        }
    }

    .el-dialog__body {
        background-color: @base-deep;
        padding: clamp(15px, 2vw, 20px);
        color: @text-primary;
        max-height: 70vh;
        overflow-y: auto;
        font-size: clamp(0.85rem, 1vw, 0.9rem);
    }

    .el-dialog__footer {
        background-color: @base-darker;
        border-top: 1px solid @border-color;
        padding: clamp(10px, 1.5vw, 15px) clamp(15px, 2vw, 20px);
        margin: 0;
        text-align: right;

        .el-button {
            padding: clamp(6px, 1.5vw, 8px) clamp(15px, 2vw, 20px);
            border-radius: 4px;
            font-size: clamp(0.85rem, 1vw, 0.9rem);

            &.el-button--primary {
                background-color: @primary;
                border-color: @primary;

                &:hover {
                    background-color: @primary-dark;
                    border-color: @primary-dark;
                }
            }
        }
    }
}

// 确认弹窗内容响应式样式
.confirm-content {
    .model-basic-info {
        background-color: @base-darker;
        border-radius: 8px;
        padding: clamp(15px, 2vw, 20px);
        margin-bottom: clamp(10px, 1.5vw, 15px);
        border: 1px solid @border-color;

        .info-row {
            display: flex;
            align-items: center;
            margin-bottom: clamp(10px, 1.5vw, 12px);
            padding-bottom: clamp(10px, 1.5vw, 12px);
            border-bottom: 1px solid rgba(148, 163, 184, 0.1);
            flex-wrap: wrap; // 小屏换行
            gap: 0.5rem;

            &:last-child {
                margin-bottom: 0;
                padding-bottom: 0;
                border-bottom: none;
            }

            .info-label {
                width: clamp(80px, 20vw, 100px);
                color: @text-secondary;
                font-size: clamp(0.8rem, 1.2vw, 14px);
                flex-shrink: 0;
            }

            .info-value {
                flex: 1;
                font-size: clamp(0.8rem, 1.2vw, 14px);
                color: @text-secondary;
                word-wrap: break-word;

                &.price {
                    color: @primary;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }
    }

    .buy-tips {
        display: flex;
        align-items: center;
        background-color: rgba(255, 152, 0, 0.1);
        border: 1px solid #ff9800;
        border-radius: 4px;
        padding: 10px 15px;
        margin-bottom: 15px;
        color: #ff9800;
        font-size: 13px;

        i {
            margin-right: 8px;
            color: #ff9800;
        }
    }

    .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        color: @text-secondary;

        i {
            font-size: 20px;
            margin: 0 10px 0 0;
            color: @primary;
            animation: rotate 1s linear infinite;
        }
    }
}

// 移除原有可能冲突的弹窗样式
::v-deep .el-dialog {
    display: block; // 取消flex布局，避免影响居中
}

::v-deep .el-dialog__body {
    padding: 20px; // 恢复默认内边距
    overflow: visible; // 取消隐藏溢出
}

::v-deep .el-dialog__header {
    border-bottom: none; // 取消全局弹窗的底部边框
    margin-bottom: 0; // 取消全局弹窗的底部外边距
    padding: 20px; // 恢复默认内边距
}

.load-tips {
    text-align: center;
    padding: 15px 0;
    color: #999;
    font-size: 14px;
}
</style>